import { RawDataRsp } from "../../model/Web";
import { API, apiRequest, apiUploadRequest } from "../api";
import { OperateReq, OperateRsp } from "./backend_op";
import { UploadImageReq, UploadImageRsp } from "./image";
import {
    GetNoticeBoardReq,
    GetNoticeBoardRsp,
    SetNoticeBoardReq,
    SetNoticeBoardRsp,
} from "./notice";
import {
    RawDataListReq,
    RawDataListRsp,
    RawDataReq,
    UserDataListReq,
    UserDataListRsp,
    UserDataReq,
    UserDataRsp,
} from "./raw";
import {
    RequestSyncSystemReq,
    RequestSyncSystemRsp,
    RequestSyncUserReq,
    RequestSyncUserRsp,
} from "./sync";
import { TodayTradeReportReq, TodayTradeReportRsp } from "./trade";

const apiGetNoticeBoard: API<GetNoticeBoardReq, GetNoticeBoardRsp> = {
    url: "/api/project/get_notice_board",
};

export function methodGetNoticeBoard(dispatch: any, req: GetNoticeBoardReq) {
    return apiRequest({ api: apiGetNoticeBoard, req, dispatch });
}

const apiSetNoticeBoard: API<SetNoticeBoardReq, SetNoticeBoardRsp> = {
    url: "/api/project/set_notice_board",
};

export function methodSetNoticeBoard(dispatch: any, req: SetNoticeBoardReq) {
    return apiRequest({ api: apiSetNoticeBoard, req, dispatch });
}

const apiRawDataList: API<RawDataListReq, RawDataListRsp> = {
    url: "/api/web/raw_data_list",
};

export function methodRawDataList(dispatch: any, req: RawDataListReq) {
    return apiRequest({ api: apiRawDataList, req, dispatch });
}

const apiRawDataOperate: API<RawDataReq, RawDataRsp> = {
    url: "/api/web/raw_data_operate",
};

export function methodRawDataOperate(dispatch: any, req: RawDataReq) {
    return apiRequest({ api: apiRawDataOperate, req, dispatch });
}

const apiUserDataOperate: API<UserDataReq, UserDataRsp> = {
    url: "/api/web/user_data_operate",
};

export function methodUserDataOperate(dispatch: any, req: UserDataReq) {
    return apiRequest({ api: apiUserDataOperate, req, dispatch });
}

const apiTodayTradeReport: API<TodayTradeReportReq, TodayTradeReportRsp> = {
    url: "/api/web/today_trade_report",
};

export function methodTodayTradeReport(dispatch: any, req: TodayTradeReportReq) {
    return apiRequest({ api: apiTodayTradeReport, req, dispatch });
}

const apiRequestSyncUser: API<RequestSyncUserReq, RequestSyncUserRsp> = {
    url: "/api/project/request_sync_user",
};

export function methodRequestSyncUser(dispatch: any, req: RequestSyncUserReq) {
    return apiRequest({ api: apiRequestSyncUser, req, dispatch, backdrop: true });
}

const apiRequestSyncSystem: API<RequestSyncSystemReq, RequestSyncSystemRsp> = {
    url: "/api/project/request_sync_system",
};

export function methodRequestSyncSystem(dispatch: any, req: RequestSyncSystemReq) {
    return apiRequest({ api: apiRequestSyncSystem, req, dispatch, backdrop: true });
}

const apiOperate: API<OperateReq, OperateRsp> = {
    url: "/api/web/operate",
};

export function methodBackendOperate(dispatch: any, req: OperateReq) {
    return apiRequest({ api: apiOperate, req, dispatch, backdrop: true, dealErr: true });
}

const apiUserDataList: API<UserDataListReq, UserDataListRsp> = {
    url: "/api/web/user_data_list",
};

export function methodUserDataList(dispatch: any, req: UserDataListReq) {
    return apiRequest({ api: apiUserDataList, req, dispatch });
}

const apiUploadImage = "/api/project/upload_image";

export function methodUploadImage(dispatch: any, req: UploadImageReq) {
    const formData = new FormData();
    formData.append("file", req.file);
    return apiUploadRequest<UploadImageRsp>({
        apiURL: apiUploadImage,
        req: formData,
        dispatch,
    });
}
